/* tslint:disable */
/* eslint-disable */
export enum AuditMode {
  Ui = 'ui',
  File = 'file',
}
